import React, { useEffect, useState, useRef } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import { Link } from "react-router-dom";

import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const BestSellerSection = () => {
  const [products, setProducts] = useState([]);
  const swiperRef = useRef(null);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const res = await fetch(
          "https://code.gurusport.in/api/site-banner"
        );

        const data = await res.json();

        if (data?.top_products?.data) {
          setProducts(data.top_products.data);
        }
      } catch (error) {
        console.error("Error fetching products:", error);
      }
    };

    fetchProducts();
  }, []);

  // Fix swiper when user returns from product page
  useEffect(() => {
    const handlePageShow = () => {
      setTimeout(() => {
        const swiper = swiperRef.current;

        if (swiper) {
          swiper.update();
          swiper.autoplay?.start();
        }
      }, 100);
    };

    window.addEventListener("pageshow", handlePageShow);

    return () => {
      window.removeEventListener("pageshow", handlePageShow);
    };
  }, []);

  return (
    <section className="relative bg-white py-16 md:py-20 overflow-hidden">
      {/* Background Glow */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-red-500/10 rounded-full blur-[180px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12 md:mb-16">
          <p className="text-red-600 uppercase tracking-[0.35em] text-[10px] font-bold mb-3">
            Most Popular
          </p>

          <h2 className="text-1xl md:text-4xl font-black text-black uppercase tracking-tight mb-4">
            Best Seller Products
          </h2>

          <p className="text-gray-400 max-w-2xl mx-auto text-sm md:text-base leading-relaxed">
            Gear up with the champions’ choice. Our best-selling collection
            delivers premium performance, durability and confidence for every
            game.
          </p>
        </div>

        {/* Product Carousel */}
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          onSwiper={(swiper) => {
            swiperRef.current = swiper;
          }}
          loop={products.length > 4}
          centeredSlides={false}
          speed={900}
          // navigation
          // pagination={{
          //   clickable: true,
          // }}
          autoplay={{
            delay: 1000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true,
          }}
          slidesPerView={4}
          slidesPerGroup={1}
          spaceBetween={30}
          observer={true}
          observeParents={true}
          updateOnWindowResize={true}
          resizeObserver={true}
          breakpoints={{
            0: {
              slidesPerView: 1,
            },
            576: {
              slidesPerView: 2,
            },
            768: {
              slidesPerView: 3,
            },
            1024: {
              slidesPerView: 4,
            },
            1400: {
              slidesPerView: 4,
            },
          }}
          className="bestSellerSwiper py-4"
        >
          {products.map((product) => (
            <SwiperSlide key={product.id}>
              <div
                className="
                  group
                  h-full
                  overflow-hidden
                  border
                  border-black/10
                  bg-white
                  rounded-xl
                  shadow-[0_10px_25px_rgba(0,0,0,0.05)]
                  transition-all
                  duration-500
                  hover:-translate-y-2
                  hover:border-red-500/50
                  hover:shadow-[0_20px_50px_rgba(0,0,0,0.15)]
                "
              >
                <Link to={`/${product.slug}`}>
                  <div
                    className="
                      relative
                      overflow-hidden
          
                    "
                  >
                    <img
                      src={
                        product.default_image
                          ? product.default_image
                          : "/images/placeholder.png"
                      }
                      alt={product.name}
                      className="
                        w-full
                        h-[340px]
                        object-contain
                        transition-all
                        duration-700
                        group-hover:scale-110
                      "
                    />
                  </div>
                </Link>

                <div className="relative p-6 text-center">
                  <h3 className="text-black font-semibold text-sm md:text-base min-h-[52px] flex items-center justify-center leading-relaxed">
                    {product.name}
                  </h3>

                  <div className="mt-2 flex items-center justify-center gap-2">
                    {product.old_price && (
                      <span className="line-through text-gray-500 text-sm">
                        ₹{product.old_price}
                      </span>
                    )}

                    <span className="text-black text-xl font-black tracking-tight">
                      ₹{product.price || "N/A"}
                    </span>
                  </div>

                  <Link
                    to={`/${product.slug}`}
                    className="
                      inline-flex
                      items-center
                      justify-center
                      mt-4
                      bg-red-500
                      text-white
                      font-black
                      uppercase
                      tracking-[0.18em]
                      text-[10px]
                      px-3
                      py-1
                      rounded-xl
                      transition-all
                      duration-300
                      hover:bg-white
                      hover:text-black
                      shadow-[0_10px_25px_rgba(239,68,68,0.35)]
                    "
                  >
                    Shop Now
                  </Link>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default BestSellerSection;